import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createTurnoverNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'scales',
  text: translateFn('mnu_acc_turnover'),
  identity: '/secure/account/turnover',
  permission: ['ACC_ACCOUNT_LIST', 'ACC_TURNOVER'],
}))

export default Loadable(() => import('./Turnover'))
